import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { DocumentsResponseSI, PostDocumentRequestBody, PostDocumentResponseSI, ViewDocumentResponseSI } from '@views/interfaces/services/documentation.interface';

@Injectable({
  providedIn: 'root',
})
export class DocumentationService {
  constructor(private _http: HttpClient) {}

  async getDocuments(idProject: string, spinner: boolean = true): Promise<DocumentsResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<DocumentsResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.DOCUMENTS.replace(':idProject',idProject)}`, {
        params: { spinner },
      })
    );
    return result.payload;
  }

  async deleteDocument(idDocument: string): Promise<void> {
    await firstValueFrom(this._http.delete(`${BASE_URL}${ENDPOINTS.DOCUMENT.replace(':idDocument', idDocument)}`));
  }

  async viewDocument(idDocument: string): Promise<ViewDocumentResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<ViewDocumentResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.DOCUMENT.replace(':idDocument', idDocument)}`)
    );
    return result.payload;
  }

  async postDocument(idDocument: string, fileName: string): Promise<PostDocumentResponseSI> {
    let body: PostDocumentRequestBody = {
      fileName,
      idDocumentList: idDocument,
    };
    const result = await firstValueFrom<ResponseCommonSI<PostDocumentResponseSI>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.DOCUMENT.replace('/:idDocument', '')}`, body)
    );
    return result.payload;
  }
  async uploadIsOk(idProject: string, spinner: boolean = true){
    const result = await firstValueFrom<ResponseCommonSI<{ uploadIsOk: boolean }>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.DOCUMENT_UPLOADISOK.replace(':idProject', idProject)}`, {
        params: { spinner },
      })
    );
    return result.payload;
  }
  async manualResolution(idProject: string, spinner: boolean = true): Promise<DocumentsResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<DocumentsResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.DOCUMENT_MANUAL.replace(':idProject',idProject)}`
      )
    );
    return result.payload;
  }
  async saveMinuteDocument(idDocument: string, fileName: string): Promise<object> {
    let body: PostDocumentRequestBody = {
      fileName,
      idDocumentList: idDocument,
    };
    const result = await firstValueFrom<ResponseCommonSI<PostDocumentResponseSI>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.DOCUMENT_SAVE_MINUTA}`, body)
    );
    return result.payload;
  }
}
